import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  loadBranchesRequested,
  storeBranchRequested,
  updateBranchRequested,
  archiveBranchRequested,
  loadBranchesListRequested,
  loadBranchRequested,
} from 'store/branch/branchSlice';

export function useStoreBranch() {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const onStoreBranch = useCallback(
    async (values: any, actions: any) => {
      actions.setSubmitting(true);
      await dispatch(storeBranchRequested(values));
      setTimeout(() => {
        actions.setSubmitting(false);
      }, 1000);
    },
    [dispatch]
  );
  return { onStoreBranch };
}

export function useLoadBranches() {
  const dispatch = useDispatch();
  const onLoadBranches = useCallback(async () => {
    await dispatch(loadBranchesRequested({ page: 1, perPage: 1000 }));
  }, [dispatch]);
  useEffect(() => {
    onLoadBranches();
  }, [onLoadBranches]);
  return { onLoadBranches };
}

export function useLoadBranchesList() {
  const dispatch = useDispatch();
  const onLoadBranchesList = useCallback(async () => {
    await dispatch(loadBranchesListRequested({}));
  }, [dispatch]);

  useEffect(() => {
    onLoadBranchesList();
  }, [onLoadBranchesList]);
  return { onLoadBranchesList };
}

export function useLoadBranch(ref: any) {
  const dispatch = useDispatch();
  const onLoadBranch = useCallback(async () => {
    await dispatch(loadBranchRequested(ref));
  }, [dispatch]);

  useEffect(() => {
    onLoadBranch();
  }, [onLoadBranch]);
  return { onLoadBranch };
}

export function useUpdateBranch() {
  const dispatch = useDispatch();
  const onUpdateBranch = useCallback(
    async (values: any) => {
      await dispatch(updateBranchRequested(values));
    },
    [dispatch]
  );
  return { onUpdateBranch };
}

export function useArchiveBranch() {
  const dispatch = useDispatch();
  const onArchiveBranch = useCallback(
    async (id: any, offerId: any) => {
      await dispatch(archiveBranchRequested({ id: id }));
    },
    [dispatch]
  );
  return { onArchiveBranch };
}
